<template>
    <div class="сertificates-filters">
        <h3 class="сertificates-filters__title">
            {{ text.searchCertificate }}
        </h3>
        <div class="row">
            <div class="col-default-6 col-mobile-12">
                <z-input
                    name="number"
                    v-model="formData.number"
                    :placeholder="text.number"
                />
            </div>
            <div
                class="col-default-6 col-mobile-12"
                v-if="data.type && data.type.length"
            >
                <z-select
                    name="type"
                    :data="data.type"
                    v-model="formData.type"
                    :placeholder="text.type"
                />
            </div>
        </div>
        <div class="row" v-show="isShowFilters">
            <div class="col-default-12">
                <z-input
                    name="agency"
                    v-model="formData.agency"
                    :placeholder="text.agency"
                />
            </div>
            <div class="col-default-6 col-mobile-12">
                <z-input
                    name="description"
                    v-model="formData.description"
                    :placeholder="text.description"
                />
            </div>
            <div
                class="col-default-6 col-mobile-12"
                v-if="data.factory && data.factory.length"
            >
                <z-select
                    name="factory"
                    :data="data.factory"
                    v-model="formData.factory"
                    :placeholder="text.factory"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-default-4 col-mobile-12">
                <z-button
                    size="l"
                    @click="send"
                    class="u-entire-width"
                >{{ text.search }}</z-button>
            </div>
            <div class="col-default-3 col-default-offset-5 col-tablet-5 col-tablet-offset-3 col-mobile-12 col-mobile-offset-0">
                <z-button
                    size="s"
                    kind="close"
                    @click="clear"
                    v-if="!isEmpty"
                >
                    {{ text.clear }}
                </z-button>
                <z-button
                    size="s"
                    kind="text"
                    @click="isShowFilters = !isShowFilters"
                    class="сertificates-filters__button"
                >
                    <template v-slot:left>
                        <z-icon
                            :name="isShowFilters ? 'close' : 'search'"
                            width="16"
                            height="16"
                        />
                    </template>
                    <span :class="[
                        'сertificates-filters__button-search',
                        { 'сertificates-filters__button-search--hide' : isShowFilters }
                    ]">
                        {{ text.advancedSearch }}
                    </span>
                </z-button>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'filters',
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        initial: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            formData: {
                number: '',
                type: '',
                agency: '',
                description: '',
                factory: ''
            },
            isShowFilters: false,
            text: {
                searchCertificate: localize({
                    ru: 'Поиск сертификата',
                    en: 'Search for a certificate'
                }),
                search: localize({
                    ru: 'Найти',
                    en: 'Search'
                }),
                clear: localize({
                    ru: 'Сбросить все',
                    en: 'Clear all'
                }),
                advancedSearch: localize({
                    ru: 'Расширенный поиск',
                    en: 'Advanced Search'
                }),
                number: localize({
                    ru: 'Номер сертификата',
                    en: 'Certificate number'
                }),
                type: localize({
                    ru: 'Тип сертификата',
                    en: 'Certificate type'
                }),
                agency: localize({
                    ru: 'Наименование органа по сертификации',
                    en: 'Certification body name'
                }),
                description: localize({
                    ru: 'Описание',
                    en: 'Description'
                }),
                factory: localize({
                    ru: 'Производство',
                    en: 'Manufacture'
                })
            }
        }
    },
    computed: {
        isEmpty () {
            return (
                this.formData.number.length === 0 &&
                this.formData.type.length === 0 &&
                this.formData.agency.length === 0 &&
                this.formData.description.length === 0 &&
                this.formData.factory.length === 0
            )
        }
    },
    methods: {
        send () {
            this.$emit('search', this.formData)
        },
        clear () {
            this.formData.number = ''
            this.formData.type = ''
            this.formData.agency = ''
            this.formData.description = ''
            this.formData.factory = ''

            this.$root.$bus.$emit('clear', 'type')
            this.$root.$bus.$emit('clear', 'factory')

            this.$emit('search', this.formData)
        }
    }
}
</script>

<style lang="scss" scoped>
.сertificates-filters {
    $parent: &;

    position: relative;
    border: 1px solid $token-colors-black-20;
    padding: $token-spacers-l;
    padding-bottom: $token-spacers-xxl;
    margin-bottom: $token-spacers-xxxl;

    &__title {
        margin-top: 0;
        margin-bottom: 32px;
    }

    &__buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        width: 100%;

        @include breakpoint(mobile) {
            .z-button--kind-text {
                width: 100%;
            }
        }
    }

    &__button {
        position: absolute;
        bottom: 20px;
        right: $token-spacers-l;

        &-search {
            border-bottom: 1px dashed $token-colors-black-40;
            transition: border-bottom $transition;

            &--hide {
                border-bottom-color: transparent;
            }
        }

        &.z-button--kind-text {
            height: 18px;
            font-size: 18px;
            font-weight: 400;
            line-height: 1;
            white-space: nowrap;
            margin-top: $token-spacers-xs;

            &:hover {
                .z-button__icon--align-left {
                    left: 0;

                    .z-icon path {
                        fill: $token-colors-black;
                    }
                }

                #{$parent}__button-search {
                    border-bottom-color: transparent;
                }
            }

            .z-icon path {
                fill: $token-colors-black;
            }
        }
    }
}
</style>
